import { render, staticRenderFns } from "./orderMsgCard.vue?vue&type=template&id=bb5e26aa&scoped=true&"
import script from "./orderMsgCard.vue?vue&type=script&lang=js&"
export * from "./orderMsgCard.vue?vue&type=script&lang=js&"
import style0 from "./orderMsgCard.vue?vue&type=style&index=0&id=bb5e26aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb5e26aa",
  null
  
)

export default component.exports